/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface DatasetColumn
 */
export interface DatasetColumn {
  /**
   *
   * @type {string}
   * @memberof DatasetColumn
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof DatasetColumn
   */
  propertyName: string;
}

/**
 * Check if a given object implements the DatasetColumn interface.
 */
export function instanceOfDatasetColumn(value: object): value is DatasetColumn {
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('propertyName' in value) || value['propertyName'] === undefined) return false;
  return true;
}

export function DatasetColumnFromJSON(json: any): DatasetColumn {
  return DatasetColumnFromJSONTyped(json, false);
}

export function DatasetColumnFromJSONTyped(json: any, ignoreDiscriminator: boolean): DatasetColumn {
  if (json == null) {
    return json;
  }
  return {
    name: json['name'],
    propertyName: json['propertyName']
  };
}

export function DatasetColumnToJSON(value?: DatasetColumn | null): any {
  if (value == null) {
    return value;
  }
  return {
    name: value['name'],
    propertyName: value['propertyName']
  };
}
